export default __webpack_public_path__ + "static/media/menu-ads.976895d0.png";